var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_13927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4379.5,
    y: -2358.5,
    width: 8999,
    height: 5999,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 641.004,
    r: 299.5,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 641.004,
    r: 479.5,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 641.004,
    r: 767.5,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.8,
    cy: 640.804,
    r: 1228.3,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.08,
    cy: 641.08,
    r: 1965.58,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.728,
    cy: 640.732,
    r: 3145.23,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.853,
    cy: 640.853,
    r: 4529.35,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4380,
    y1: 640.504,
    x2: 4620,
    y2: 640.504,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4380.14,
    y1: 2001.53,
    x2: 4619.85,
    y2: -720.479,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 9402.62,
    y2: -0.5,
    transform: "matrix(0.95718 0.289495 0.289495 -0.95718 -4380 -720)",
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.5,
    y1: 3641,
    x2: 119.5,
    y2: -2359,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1939.57,
    y1: 3641.26,
    x2: -1700.43,
    y2: -2358.74,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7017.81,
    y2: -0.5,
    transform: "matrix(0.51868 -0.854968 -0.854968 -0.51868 -1700 3641)",
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2880,
    y1: 640.504,
    x2: 3120,
    y2: 640.504,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4380.28,
    y1: 3640.58,
    x2: 4619.72,
    y2: -2359.42,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4380.28,
    y1: 3640.58,
    x2: 4619.72,
    y2: -2359.42,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 10816.7,
    y2: -0.5,
    transform: "matrix(-0.83205 -0.5547 -0.5547 0.83205 4620 3641)",
    stroke: "black",
    strokeOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_13927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9000,
    height: 6000,
    fill: "white",
    transform: "translate(-4380 -2359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkTablet);
export default __webpack_public_path__ + "static/media/watermark-tablet.18d3d59ac8a4b7bf3d6bdc80a0bbd132.svg";
export { ForwardRef as ReactComponent };